// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3Gh-J","empty":"ModalGraph_empty__1-0nU"};